// ═══════════════════════════════════════════════════════════════
// Breadcrumbs — lightweight navigation trail
// Usage: <Breadcrumbs items={[{ label: 'PA Grants', to: '/pagrants/pa' }, { label: 'Projects' }]} />
// ═══════════════════════════════════════════════════════════════

import { useNavigate } from 'react-router-dom';
import { Group, Text } from '../gab/GabComponents';
import { IconChevronRight } from '@tabler/icons-react';

export interface BreadcrumbItem {
  label: string;
  to?: string;
}

export default function Breadcrumbs({ items }: { items: BreadcrumbItem[] }) {
  const navigate = useNavigate();

  return (
    <nav aria-label="Breadcrumb">
      <Group gap={4} mb="sm" style={{ flexWrap: 'wrap' }}>
        {items.map((item, i) => {
          const isLast = i === items.length - 1;
          return (
            <Group key={i} gap={4}>
              {i > 0 && <IconChevronRight size={12} color="#adb5bd" aria-hidden="true" />}
              {item.to && !isLast ? (
                <button
                  type="button"
                  style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', font: 'inherit', color: 'var(--color-primary-700)', fontWeight: 500, fontSize: 'var(--font-size-xs)' }}
                  onClick={() => navigate(item.to!)}
                >
                  {item.label}
                </button>
              ) : (
                <Text size="xs" c={isLast ? 'dark' : 'dimmed'} fw={isLast ? 600 : 400} aria-current={isLast ? 'page' : undefined}>
                  {item.label}
                </Text>
              )}
            </Group>
          );
        })}
      </Group>
    </nav>
  );
}
